import { render, staticRenderFns } from "./RedactorBriefPanel.vue?vue&type=template&id=a90b0820&"
import script from "./RedactorBriefPanel.vue?vue&type=script&lang=js&"
export * from "./RedactorBriefPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports